import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  TextField,
  Card,
  CardContent,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as services from "../../services/services";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";
import { formatDate } from "../../utils/formatDate";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import IMG from "../../images/istockphoto.jpg";
import QRCode from "react-qr-code";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
const PetDetailPage = () => {
  const { id } = useParams();
  const [pet, setPet] = useState(null);
  const [history, setHistory] = useState([]);
  const [openOwnerDialog, setOpenOwnerDialog] = useState(false);
  const [openQrDialog, setOpenQrDialog] = useState(false);
  const [selectedOwnerId, setSelectedOwnerId] = useState("");
  const navigate = useNavigate();
  const [owners, setOwners] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [mode, setMode] = useState("select"); // select | create
  const [newOwner, setNewOwner] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    idCard: "",
    address: "",
    subDistrict: "",
    district: "",
    province: "",
  });
  const [search, setSearch] = useState("");
  const fetchOwners = async () => {
    const res = await services.getOwnersByHospital();
    setOwners(res.data.data);
  };
  const filteredOwners =
    search.trim() === ""
      ? []
      : owners.filter((o) => {
        const keyword = search.toLowerCase();
        return (
          `${o.firstName} ${o.lastName}`.toLowerCase().includes(keyword) ||
          o.phoneNumber?.includes(search) ||
          o.ownerCode?.includes(search) ||
          o.idCard?.includes(search)
        );
      });
  const fetchPet = async () => {
    const res = await services.getPetById(id);
    setPet(res.data.data);

    // 1. Map internal history
    const internalHistory = res.data.data.treatments.map((item, index) => {
      let sType = "ฝังไมโครชิพ";
      if (item.serviceType === "vaccine") sType = "ฉีดวัคซีน";
      else if (item.serviceType === "parasite") sType = "ป้องกันปรสิต";

      return {
        id: index + 1,
        treatmentsId: item.id,
        serviceType: sType,
        serviceDate: formatDate(item.serviceDate),
        rawDate: item.serviceDate,
        handledBy:
          item.handledBy.title +
          " " +
          item.handledBy.name +
          " " +
          item.handledBy.lastname,
        note: item.note,
        isFromBow: false
      };
    });

    let finalHistory = [...internalHistory];

    const accessToken = localStorage.getItem("accessToken");
    let myHospitalId = null;
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        myHospitalId = decoded.hospitalId;
      } catch (err) {
        console.error("JWT Decode error", err);
      }
    }

    // 2. Fetch combined records if pet is linked to Bow
    if (res.data.data.petCode) {
      try {
        const combinedRes = await services.getCombinedRecords(res.data.data.petCode);

        // Merge vaccines
        if (combinedRes.data.vaccines) {
          combinedRes.data.vaccines.forEach(v => {
            const isDuplicate = myHospitalId && v.created_hospital_id === myHospitalId;

            if (!isDuplicate) {
              finalHistory.push({
                id: `bow-v-${v.id || Math.random()}`,
                treatmentsId: `bow-v-${v.id}`,
                serviceType: "ฉีดวัคซีน",
                serviceDate: formatDate(v.date),
                handledBy: v.vet_name || v.vet_hospital_name || "-",
                note: v.note || "-",
                isFromBow: true,
                type: 'vaccine',
                bowData: v
              });
            }
          });
        }

        // Merge parasites
        if (combinedRes.data.parasites) {
          combinedRes.data.parasites.forEach(p => {
            const isDuplicate = myHospitalId && p.created_hospital_id === myHospitalId;

            if (!isDuplicate) {
              finalHistory.push({
                id: `bow-p-${p.id || Math.random()}`,
                treatmentsId: `bow-p-${p.id}`,
                serviceType: "ป้องกันปรสิต",
                serviceDate: formatDate(p.date),
                handledBy: p.vet_name || p.vet_hospital_name || "-",
                note: p.note || "-",
                isFromBow: true,
                type: 'parasite',
                bowData: p
              });
            }
          });
        }
      } catch (err) {
        console.error("Failed to fetch combined records", err);
      }
    }

    // sort history by descending date
    finalHistory.sort((a, b) => {
      const aDate = new Date(a.rawDate || a.bowData?.date || a.serviceDate).getTime() || 0;
      const bDate = new Date(b.rawDate || b.bowData?.date || b.serviceDate).getTime() || 0;
      return bDate - aDate;
    });

    setHistory(finalHistory);
  };
  const handleChangeOwner = async () => {
    await services.updatePetOwner(pet.id, {
      ownerId: selectedOwnerId,
    });
    setOpenOwnerDialog(false);
    toast.success("เพิ่มเจ้าของสำเร็จ!");

    fetchPet();
  };
  useEffect(() => {
    fetchPet();
    if (openOwnerDialog) {
      fetchOwners();
    }
  }, [openOwnerDialog]);
  const handleCreateOwner = async () => {
    try {
      const res = await services.createOwner(newOwner);
      toast.success("เพิ่มเจ้าของสำเร็จ");
      setOwners((prev) => [...prev, res.data.data]);
      setSelectedOwnerId(res.data.data.id);
      setNewOwner({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        idCard: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
      });
      setMode("select");
    } catch (err) {
      console.log(err.status);
      if (err.status === 409) {
        toast.error("เพิ่มเจ้าของไม่สำเร็จ มีเลขบัตรนี้ในระบบแล้ว");
      } else {
        toast.error("เพิ่มเจ้าของไม่สำเร็จ");
      }
    }
  };
  const downloadCertificate = async () => {
    const res = await services.getCertificate(pet.id);
    const pdfUrl = res.data.pdfUrl;
    if (!pdfUrl) return;

    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };
  const calculateAgeText = (birthdate) => {
    if (!birthdate) return "-";

    const birth = new Date(birthdate);
    const today = new Date();

    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();

    if (today.getDate() < birth.getDate()) {
      months -= 1;
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return `${years} ปี ${months} เดือน`;
  };
  if (!pet) return <Typography>Loading...</Typography>;

  return (
    <>
      <Toaster />

      <AppBreadcrumbs />
      <Box sx={{ p: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h5">
            ข้อมูลสัตว์เลี้ยง {pet.hospitalPetCode}
          </Typography>

          <Box>
            <Button
              startIcon={<QrCodeIcon />}
              size="small"
              onClick={() => setOpenQrDialog(true)}
              sx={{ mr: 1 }}
            >
              QR Code
            </Button>

            <Button
              startIcon={<ConnectWithoutContactIcon />}
              size="small"
              variant="outlined"
              onClick={() => navigate(`/pets/${pet.id}/connect`)}
            >
              ขอเชื่อมต่อ
            </Button>
          </Box>
        </Box>

        <Paper sx={{ p: 2, mb: 4 }}>
          <Grid container spacing={2}>
            {/* รูป */}

            <Grid item xs={12} md={4}>
              <img
                src={pet.image ? pet.image : IMG}
                alt={pet.name}
                style={{
                  width: pet.image ? "70%" : "100%",
                  borderRadius: 8,
                }}
              />
            </Grid>

            {/* ข้อมูล */}
            <Grid item xs={12} md={8}>
              {/* ชื่อสัตว์ */}
              <Typography variant="h6" sx={{ mb: 2 }}>
                ชื่อ: {pet.name}
              </Typography>

              {/* ---------- ส่วนที่ 1: ข้อมูลสัตว์เลี้ยง ---------- */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  ข้อมูลสัตว์เลี้ยง
                </Typography>
              </Box>

              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ชนิดสัตว์:
                  </Typography>{" "}
                  {pet.type}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    สายพันธุ์:
                  </Typography>{" "}
                  {pet.breed}
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    เพศ:
                  </Typography>{" "}
                  {{ m: "ตัวผู้", f: "ตัวเมีย", b: "ไม่ทราบ" }[pet.gender] ||
                    "-"}
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    วันเกิด:
                  </Typography>{" "}
                  {formatDate(pet.birthdate)}
                  {"    "}
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    อายุ:
                  </Typography>{" "}
                  {calculateAgeText(pet.birthdate)}
                </Grid>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ทำหมัน:
                  </Typography>{" "}
                  {pet.neutered === "yes" ? "ทำแล้ว" : "ยัง"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    สีตา:
                  </Typography>{" "}
                  {pet.eyeColor}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    สีขน:
                  </Typography>{" "}
                  {pet.furColor}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ตำหนิ:
                  </Typography>{" "}
                  {pet.appearanceDetail || "-"}
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ไมโครชิป:
                  </Typography>{" "}
                  {pet.microchipNumber || "-"}
                  <Button
                    sx={{ ml: 3 }}
                    size="small"
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    disabled={!pet.microchipNumber}
                    onClick={() => {
                      downloadCertificate();
                    }}
                  >
                    โหลดใบรับรอง
                  </Button>
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    กรุ๊ปเลือด:
                  </Typography>{" "}
                  {pet.bloodGroup}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ยาที่แพ้:
                  </Typography>{" "}
                  {pet.drugAllergies || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    อาหารที่แพ้:
                  </Typography>{" "}
                  {pet.foodAllergies || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    โรคประจำตัว:
                  </Typography>{" "}
                  {pet.diseases || "-"}
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    เจ้าของ:
                  </Typography>{" "}
                  {pet?.owner
                    ? `${pet.owner.firstName} ${pet.owner.lastName}`
                    : "ไม่มีเจ้าของ"}
                  <Button
                    sx={{ ml: 3 }}
                    size="small"
                    variant="outlined"
                    startIcon={<CompareArrowsIcon />}
                    onClick={() => {
                      setMode("select");
                      setOpenOwnerDialog(true);
                    }}
                  >
                    เปลี่ยน/เพิ่มเจ้าของ
                  </Button>
                </Grid>
              </Grid>

              {/* ---------- ส่วนที่ 2: ข้อมูลพ่อแม่ ---------- */}
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 4 }}
              >
                ข้อมูลพ่อแม่
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ชื่อพ่อ:
                  </Typography>{" "}
                  {pet.fatherName || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ไมโครชิปพ่อ:
                  </Typography>{" "}
                  {pet.fatherMicrochipNumber || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ชื่อแม่:
                  </Typography>{" "}
                  {pet.motherName || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ไมโครชิปแม่:
                  </Typography>{" "}
                  {pet.motherMicrochipNumber || "-"}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>

        <Typography variant="h5" sx={{ mb: 2 }}>
          ประวัติการฉีดวัคซีน
        </Typography>
        <Paper sx={{ height: 300, mb: 4 }}>
          <DataGrid
            rows={history.filter((h) => h.serviceType === "ฉีดวัคซีน")}
            columns={[
              { field: "serviceDate", headerName: "วันที่", flex: 1 },
              {
                field: "isFromBow",
                headerName: "แหล่งข้อมูล",
                flex: 1,
                renderCell: (params) => (
                  <Typography
                    sx={{
                      color: params.value ? "#ed6c02" : "#2e7d32",
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    {params.value ? "เจ้าของ / ส่วนกลาง" : "โรงพยาบาล"}
                  </Typography>
                ),
              },
              { field: "handledBy", headerName: "แพทย์/สถานพยาบาล", flex: 1 },
              { field: "note", headerName: "หมายเหตุ", flex: 1 },
              {
                field: "detail",
                headerName: "รายละเอียด",
                flex: 1,
                renderCell: (params) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <AssignmentIcon
                      style={{
                        color: params.row.isFromBow ? "#fb8c00" : "#1976d2",
                        cursor: "pointer",
                      }}
                      titleAccess={
                        params.row.isFromBow
                          ? "ดูประวัติกลาง (Bow System)"
                          : "ดูประวัติในระบบ"
                      }
                      onClick={() => {
                        if (params.row.isFromBow) {
                          navigate(
                            `/bow_medical_history/${params.row.treatmentsId}`,
                            { state: { bowData: params.row.bowData, pet: pet, type: params.row.type } }
                          );
                        } else {
                          navigate(
                            `/medical_history/${params.row.treatmentsId}`,
                            { state: params.row }
                          );
                        }
                      }}
                    />
                  </div>
                ),
              },
            ]}
          />
        </Paper>

        <Typography variant="h5" sx={{ mb: 2 }}>
          ประวัติการรับยาป้องกันพยาธิ / ปรสิต
        </Typography>
        <Paper sx={{ height: 300, mb: 4 }}>
          <DataGrid
            rows={history.filter((h) => h.serviceType === "ป้องกันปรสิต")}
            columns={[
              { field: "serviceDate", headerName: "วันที่", flex: 1 },
              {
                field: "isFromBow",
                headerName: "แหล่งข้อมูล",
                flex: 1,
                renderCell: (params) => (
                  <Typography
                    sx={{
                      color: params.value ? "#ed6c02" : "#2e7d32",
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    {params.value ? "เจ้าของ / ส่วนกลาง" : "โรงพยาบาล"}
                  </Typography>
                ),
              },
              { field: "handledBy", headerName: "แพทย์/สถานพยาบาล", flex: 1 },
              { field: "note", headerName: "หมายเหตุ", flex: 1 },
              {
                field: "detail",
                headerName: "รายละเอียด",
                flex: 1,
                renderCell: (params) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <AssignmentIcon
                      style={{
                        color: params.row.isFromBow ? "#fb8c00" : "#1976d2",
                        cursor: "pointer",
                      }}
                      titleAccess={
                        params.row.isFromBow
                          ? "ดูประวัติกลาง (Bow System)"
                          : "ดูประวัติในระบบ"
                      }
                      onClick={() => {
                        if (params.row.isFromBow) {
                          navigate(
                            `/bow_medical_history/${params.row.treatmentsId}`,
                            { state: { bowData: params.row.bowData, pet: pet, type: params.row.type } }
                          );
                        } else {
                          navigate(
                            `/medical_history/${params.row.treatmentsId}`,
                            { state: params.row }
                          );
                        }
                      }}
                    />
                  </div>
                ),
              },
            ]}
          />
        </Paper>

        <Typography variant="h5" sx={{ mb: 2 }}>
          ประวัติการฝังไมโครชิพ
        </Typography>
        <Paper sx={{ height: 300, mb: 4 }}>
          <DataGrid
            rows={history.filter((h) => h.serviceType === "ฝังไมโครชิพ")}
            columns={[
              { field: "serviceDate", headerName: "วันที่", flex: 1 },
              {
                field: "isFromBow",
                headerName: "แหล่งข้อมูล",
                flex: 1,
                renderCell: (params) => (
                  <Typography
                    sx={{
                      color: params.value ? "#ed6c02" : "#2e7d32",
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    {params.value ? "เจ้าของ / ส่วนกลาง" : "โรงพยาบาล"}
                  </Typography>
                ),
              },
              { field: "handledBy", headerName: "แพทย์/สถานพยาบาล", flex: 1 },
              { field: "note", headerName: "หมายเหตุ", flex: 1 },
              {
                field: "detail",
                headerName: "รายละเอียด",
                flex: 1,
                renderCell: (params) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <AssignmentIcon
                      style={{
                        color: params.row.isFromBow ? "#fb8c00" : "#1976d2",
                        cursor: "pointer",
                      }}
                      titleAccess={
                        params.row.isFromBow
                          ? "ดูประวัติกลาง (Bow System)"
                          : "ดูประวัติในระบบ"
                      }
                      onClick={() => {
                        if (params.row.isFromBow) {
                          navigate(
                            `/bow_medical_history/${params.row.treatmentsId}`,
                            { state: { bowData: params.row.bowData, pet: pet, type: params.row.type } }
                          );
                        } else {
                          navigate(
                            `/medical_history/${params.row.treatmentsId}`,
                            { state: params.row }
                          );
                        }
                      }}
                    />
                  </div>
                ),
              },
            ]}
          />
        </Paper>
      </Box>
      <Dialog open={openOwnerDialog} onClose={() => setOpenOwnerDialog(false)}>
        <DialogTitle>
          {mode === "select" ? "เปลี่ยนเจ้าของสัตว์เลี้ยง" : "เพิ่มเจ้าของใหม่"}
        </DialogTitle>

        <DialogContent sx={{ minWidth: 600 }}>
          {mode === "select" ? (
            <>
              {/* ช่องค้นหา */}
              <TextField
                fullWidth
                sx={{ mt: 2 }}
                label="ค้นหาเจ้าของ (OwnerID/ ชื่อ / เบอร์โทร)"
                placeholder="พิมพ์ชื่อหรือเบอร์โทร"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {/* ปุ่มเพิ่มเจ้าของ */}
              <Button
                startIcon={<AddIcon />}
                sx={{ mt: 2 }}
                onClick={() => setMode("create")}
              >
                เพิ่มเจ้าของใหม่
              </Button>

              {/* แสดงผลลัพธ์เมื่อมีการค้นหาแล้วเท่านั้น */}
              {search.trim() !== "" && (
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  {filteredOwners.map((owner) => (
                    <Grid item xs={12} md={6} key={owner.id}>
                      <Card
                        sx={{
                          cursor: "pointer",
                          border:
                            selectedOwnerId === owner.id
                              ? "2px solid"
                              : "1px solid #e0e0e0",
                          borderColor:
                            selectedOwnerId === owner.id
                              ? "primary.main"
                              : undefined,
                        }}
                        onClick={() => setSelectedOwnerId(owner.id)}
                      >
                        <CardContent>
                          <Typography>{owner.ownerCode}</Typography>
                          <Typography>
                            {owner.firstName} {owner.lastName}
                          </Typography>
                          <Typography color="text.secondary">
                            เบอร์โทร: {owner.phoneNumber || "-"}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}

                  {filteredOwners.length === 0 && (
                    <Grid item xs={12}>
                      <Typography align="center" color="text.secondary">
                        ไม่พบข้อมูล
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              )}
            </>
          ) : (
            <>
              <TextField
                label="ชื่อ"
                fullWidth
                sx={{ mt: 1 }}
                value={newOwner.firstName}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, firstName: e.target.value })
                }
              />
              <TextField
                label="นามสกุล"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.lastName}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, lastName: e.target.value })
                }
              />
              <TextField
                label="เลขบัตรประชาชน"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.idCard}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, idCard: e.target.value })
                }
              />
              <TextField
                label="เบอร์โทร"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.phoneNumber}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, phoneNumber: e.target.value })
                }
              />{" "}
              <TextField
                label="ที่อยู่"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.address}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, address: e.target.value })
                }
              />{" "}
              <TextField
                label="ตำบล"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.subDistrict}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, subDistrict: e.target.value })
                }
              />
              <TextField
                label="อำเภอ"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.district}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, district: e.target.value })
                }
              />{" "}
              <TextField
                label="จังหวัด"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.province}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, province: e.target.value })
                }
              />
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              if (mode === "create") {
                setMode("select");
              } else {
                setOpenOwnerDialog(false);
              }
            }}
          >
            ยกเลิก
          </Button>

          {mode === "select" ? (
            <Button
              variant="contained"
              disabled={!selectedOwnerId}
              onClick={handleChangeOwner}
            >
              บันทึก
            </Button>
          ) : (
            <Button variant="contained" onClick={handleCreateOwner}>
              บันทึกเจ้าของ
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openQrDialog}
        onClose={() => setOpenQrDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>QR Code สัตว์เลี้ยง</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: 4,
          }}
        >
          {pet && (
            <div
              style={{
                height: "auto",
                margin: "0 auto",
                maxWidth: 256,
                width: "100%",
              }}
            >
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={pet.hospitalPetCode || pet.id}
                viewBox={`0 0 256 256`}
              />
            </div>
          )}
          <Typography sx={{ mt: 2, fontWeight: "bold" }}>
            {pet?.hospitalPetCode}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenQrDialog(false)}>ปิด</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PetDetailPage;
